namespace Matrix.Data {
    export namespace ClientFieldService {
        export const baseUrl = 'Data/ClientField';

        export declare function Create(request: Serenity.SaveRequest<ClientFieldRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ClientFieldRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function BatchDelete(request: ClientFieldBatchDeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ClientFieldRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ClientFieldRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Data/ClientField/Create",
            Update = "Data/ClientField/Update",
            Delete = "Data/ClientField/Delete",
            BatchDelete = "Data/ClientField/BatchDelete",
            Retrieve = "Data/ClientField/Retrieve",
            List = "Data/ClientField/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'BatchDelete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>ClientFieldService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
